import * as React from 'react'
import { BarChart3, Github, ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const Header: React.FC = () => {
  return (
    <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <BarChart3 className="h-6 w-6 text-primary" />
            <h1 className="text-xl font-bold">WarcraftLogs Analyzer</h1>
          </div>
          
          <nav className="flex items-center space-x-4">
            <Button variant="ghost" size="sm" asChild>
              <a
                href="https://www.warcraftlogs.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-1"
              >
                <span>WarcraftLogs</span>
                <ExternalLink className="h-3 w-3" />
              </a>
            </Button>
            
            <Button variant="ghost" size="sm" asChild>
              <a
                href="https://github.com/your-org/log-agent"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-1"
              >
                <Github className="h-4 w-4" />
                <span className="sr-only">GitHub</span>
              </a>
            </Button>
          </nav>
        </div>
      </div>
    </header>
  )
}